import React from 'react';
import cn from 'bem-cn';

import './CourseCardSkeleton.scss';

const b = cn('course-skeleton');

export const CourseCardSkeleton: React.FC = () => {
    return (
        <div className={b()}>
            <div className={b('image')} />
            <div className={b('header')}>
                <div className={b('logo')} />
                <div className={b('badge')} />
            </div>
            <div className={b('title')} />
            <div className={b('subtitle')}>
                <div className={b('subtitle-line')} />
                <div className={b('subtitle-line', { short: true })} />
            </div>
        </div>
    );
};
